let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jh5pY")).then(() => parcelRequire('fAnet'));